import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import isEqual from "lodash/isEqual"
import { Context, ScoresSchema, Transitions } from "../../../types"
import {
  downloadScoresByStudentTransition,
  getScoresByStudentTransition
} from "../../../states/admin/transitionalStates"

export const spv2ProgressByStudentState: StateNodeConfig<
  Context,
  ScoresSchema,
  Transitions,
  BaseActionObject
> = {
  id: "sp_v2_progress_by_student_state",
  initial: "loading",
  states: {
    loading: { ...getScoresByStudentTransition },

    download_scores_by_student: { ...downloadScoresByStudentTransition },

    idle: {
      on: {
        GET_SCORES_BY_STUDENT: {
          target: "loading"
        },
        DOWNLOAD_SCORES_BY_STUDENT: {
          target: "download_scores_by_student"
        }
      }
    }
  },
  on: {
    UPDATE_REPORTING_FILTERS_STATE: {
      target: "loading",
      cond: (ctx, event) => !isEqual(ctx.reportingFiltersState, event.state),
      actions: assign((_ctx, event) => ({
        reportingFiltersState: event.state
      }))
    }
  }
}
